/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListEntry } from './listEntry';

/**
 * The default order of list entries depends on business criteria.
 */
export interface GetListResponse {
  list?: Array<ListEntry>;
}
